import { UAParser } from 'ua-parser-js';
export const isMobileDevice = () => {
    var _a;
    const uiParser = new UAParser();
    return ((_a = (uiParser.getDevice().type === UAParser.DEVICE.MOBILE || uiParser.getDevice().type === UAParser.DEVICE.TABLET)) !== null && _a !== void 0 ? _a : false);
};
